import { createStore } from '@/common/pinia';
import type { ApiResponse } from '@/common/services/api.service-new';
import type { EcoregionsLayerResponse, EcoregionsStatsResponse } from './ecoregions.types';

/**
 * Cache for the RESOLVE Ecoregions 2017 product served via the analytics infrastructure
 * (`<EcoregionsTool>`). The layer response carries all three colourings' tile URLs +
 * legends in one payload, so it's a single slot (fetched once). Stats are cached per
 * `JSON.stringify(coords)` — the dataset is a single fixed epoch, so the AOI polygon is
 * the only discriminator. Sibling of `EsaBiomassStore`.
 */
class EcoregionsStore {
  private layer: ApiResponse<EcoregionsLayerResponse> | null = null;

  /** Per-polygon stats keyed by `JSON.stringify(coords)`. */
  private statsCache: Map<string, EcoregionsStatsResponse> = new Map();

  public getLayer(): ApiResponse<EcoregionsLayerResponse> | null {
    return this.layer;
  }

  public setLayer(layer: ApiResponse<EcoregionsLayerResponse>): void {
    this.layer = layer;
  }

  public getStatsCache(fingerprint: string): EcoregionsStatsResponse | undefined {
    return this.statsCache.get(fingerprint);
  }

  public setStatsCache(fingerprint: string, stats: EcoregionsStatsResponse): void {
    this.statsCache.set(fingerprint, stats);
  }
}

const useEcoregionsStore = createStore(EcoregionsStore);

export { useEcoregionsStore, type EcoregionsStore };
